export function initializeSawVideoTutorial() {
  const didSeeVideoTutorial = localStorage.getItem("didSeeVideoTutorial");
  if (didSeeVideoTutorial === null) {
    localStorage.setItem("didSeeVideoTutorial", "false");
  }
}

export function clearSawVideoTutorial() {
  localStorage.removeItem("didSeeVideoTutorial");
}

export function setSawVideoTutorial(didSeeVideoTutorial: boolean) {
  localStorage.setItem(
    "didSeeVideoTutorial",
    didSeeVideoTutorial ? "true" : "false"
  );
}

export function getSawVideoTutorial(): boolean {
  const didSeeVideoTutorial = localStorage.getItem("didSeeVideoTutorial");
  return didSeeVideoTutorial !== null && didSeeVideoTutorial === "true";
}
